var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        function() {
          return [
            _c("div", { staticClass: "single container-max page-content" }, [
              _c("div", { staticClass: "row position-relative" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-lg-6 my-3 my-md-5 img-carousel" },
                  [_vm._t("image-carousel")],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-lg-6 my-3 my-md-5" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "stick-in-parent",
                          rawName: "v-stick-in-parent"
                        }
                      ]
                    },
                    [
                      _c("div", { staticClass: "mb-2" }, [
                        _c("span", { staticClass: "articlenumber" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$translate("Ceres::Template.singleItemNumber")
                            ) +
                              " " +
                              _vm._s(_vm.currentVariation.item.id)
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "h1",
                        {
                          staticClass: "h2 title",
                          attrs: { "data-testing": "item-name" }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm._f("itemName")(_vm.currentVariation)
                                ) +
                                "\n              "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "img-addition d-inline-block" },
                            [
                              _vm.hasProp72Summer
                                ? _c("div", [
                                    _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        src: _vm.$translate(
                                          "RZOVueJSTheme::Single.summer"
                                        ),
                                        alt: "Sommerreifen"
                                      }
                                    })
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasProp72Winter
                                ? _c("div", [
                                    _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        src: _vm.$translate(
                                          "RZOVueJSTheme::Single.winter"
                                        ),
                                        alt: "Winterreifen"
                                      }
                                    })
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasProp72AllRad
                                ? _c("div", [
                                    _c("img", {
                                      staticClass: "img-fluid",
                                      attrs: {
                                        src: _vm.$translate(
                                          "RZOVueJSTheme::Single.allRad"
                                        ),
                                        alt: "Allwetterreifen"
                                      }
                                    })
                                  ])
                                : _vm._e()
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "my-5" }, [
                        _c(
                          "ul",
                          {
                            staticClass: "nav nav-tabs",
                            attrs: { role: "tablist" }
                          },
                          [
                            _vm.isDescriptionTabActive || _vm.hasGroupId3
                              ? _c("li", { staticClass: "nav-item" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "nav-link active",
                                      attrs: {
                                        "data-toggle": "tab",
                                        href:
                                          "#details-" +
                                          _vm.currentVariation.variation.id,
                                        role: "tab"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemDescription"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._t("fs-accessory-tab"),
                            _vm._v(" "),
                            _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  class: {
                                    active:
                                      !_vm.isDescriptionTabActive &&
                                      _vm.isTechnicalDataTabActive &&
                                      !_vm.hasGroupId3
                                  },
                                  attrs: {
                                    "data-toggle": "tab",
                                    href:
                                      "#data-" +
                                      _vm.currentVariation.variation.id,
                                    role: "tab",
                                    "data-plim": "BitteBeachtenTab"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemTechnicalData"
                                      )
                                    )
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  attrs: {
                                    "data-toggle": "tab",
                                    href: "#service-details",
                                    role: "tab",
                                    "data-plim": "beratungTab"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "RZOVueJSTheme::Single.service"
                                      )
                                    )
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  attrs: {
                                    "data-toggle": "tab",
                                    href: "#guarantee-details",
                                    role: "tab",
                                    "data-plim": "aenderungswuenscheTab"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "RZOVueJSTheme::Single.guarantee"
                                      )
                                    )
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _vm._t("add-detail-tabs")
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "tab-content overflow-hidden" },
                          [
                            _vm.isDescriptionTabActive || _vm.hasGroupId3
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "tab-pane active overflow-hidden fs-description",
                                    attrs: {
                                      id:
                                        "details-" +
                                        _vm.currentVariation.variation.id,
                                      role: "tabpanel"
                                    }
                                  },
                                  [
                                    _vm.hasGroupId3
                                      ? [
                                          _c(
                                            "table",
                                            { staticClass: "prop-data my-4" },
                                            [
                                              _c(
                                                "tbody",
                                                [
                                                  _vm._l(
                                                    _vm.propertyGroupList,
                                                    function(property) {
                                                      return [
                                                        property.values.value !=
                                                          "" &&
                                                        property.id != 81 &&
                                                        property.id != 14 &&
                                                        property.id != 15 &&
                                                        property.id != 65
                                                          ? _c(
                                                              "tr",
                                                              {
                                                                staticClass:
                                                                  "d-flex"
                                                              },
                                                              [
                                                                _c("td", {
                                                                  staticClass:
                                                                    "name",
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      property
                                                                        .names
                                                                        .name
                                                                    )
                                                                  }
                                                                }),
                                                                _vm._v(" "),
                                                                _c("td", {
                                                                  staticClass:
                                                                    "value",
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      property
                                                                        .values
                                                                        .value
                                                                    )
                                                                  }
                                                                })
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            ]
                                          )
                                        ]
                                      : [
                                          _c("div", {
                                            staticClass: "my-4 description",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.currentVariation.texts
                                                  .description
                                              )
                                            }
                                          })
                                        ]
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "tab-pane",
                                attrs: {
                                  id: "fs-accessory",
                                  role: "tabpanel",
                                  "data-plim": "ZubehoerItemsContent"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "my-4" },
                                  [_vm._t("fs-accessory")],
                                  2
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.isTechnicalDataTabActive
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "tab-pane overflow-auto",
                                    class: {
                                      active:
                                        !_vm.isDescriptionTabActive &&
                                        _vm.isTechnicalDataTabActive &&
                                        !_vm.hasGroupId3
                                    },
                                    attrs: {
                                      id:
                                        "data-" +
                                        _vm.currentVariation.variation.id,
                                      role: "tabpanel",
                                      "data-plim": "BitteBeachtenContent"
                                    }
                                  },
                                  [
                                    _vm.hasProp81
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "my-4 beachten-slot"
                                            },
                                            [_vm._t("beachten-description")],
                                            2
                                          )
                                        ]
                                      : [
                                          _c("div", {
                                            staticClass: "my-4 beachten-old",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.currentVariation.texts
                                                  .technicalData
                                              )
                                            }
                                          })
                                        ]
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "tab-pane overflow-auto",
                                attrs: {
                                  id: "service-details",
                                  role: "tabpanel",
                                  "data-plim": "beratungContent"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "my-4" },
                                  [_vm._t("servicecat-description")],
                                  2
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "tab-pane overflow-auto",
                                attrs: {
                                  id: "guarantee-details",
                                  role: "tabpanel",
                                  "data-plim": "aenderungswuenscheContent"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "my-4" },
                                  [_vm._t("guaranteecat-description")],
                                  2
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._t("add-detail-tabs-content")
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _vm.attributes.length || Object.keys(_vm.units).length
                        ? _c(
                            "div",
                            { staticClass: "v-select" },
                            [_c("variation-select")],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "fs-pricebox d-flex flex-wrap p-3" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "fs-itemusp d-flex flex-wrap order-2 order-xl-1 mt-4 mt-xl-0"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "item d-flex mb-3 mr-3" },
                                [
                                  _c("img", {
                                    staticClass: "img-fluid mr-2",
                                    attrs: {
                                      src: _vm.$translate(
                                        "RZOVueJSTheme::SingleUSPs.usp1Icon"
                                      ),
                                      alt: _vm.$translate(
                                        "RZOVueJSTheme::SingleUSPs.usp1Head"
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "font-weight-bold m-0 font-usuzi text-uppercase"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "RZOVueJSTheme::SingleUSPs.usp1Head"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "m-0" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "RZOVueJSTheme::SingleUSPs.usp1Text"
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "item d-flex mb-3 mr-3" },
                                [
                                  _c("img", {
                                    staticClass: "img-fluid mr-2",
                                    attrs: {
                                      src: _vm.$translate(
                                        "RZOVueJSTheme::SingleUSPs.usp2Icon"
                                      ),
                                      alt: _vm.$translate(
                                        "RZOVueJSTheme::SingleUSPs.usp2Head"
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "font-weight-bold m-0 font-usuzi text-uppercase"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "RZOVueJSTheme::SingleUSPs.usp2Head"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "m-0" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "RZOVueJSTheme::SingleUSPs.usp2Text"
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "item d-flex mb-3 mb-xl-5 mr-3"
                                },
                                [
                                  _c("img", {
                                    staticClass: "img-fluid mr-2",
                                    attrs: {
                                      src: _vm.$translate(
                                        "RZOVueJSTheme::SingleUSPs.usp3Icon"
                                      ),
                                      alt: _vm.$translate(
                                        "RZOVueJSTheme::SingleUSPs.usp3Head"
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "font-weight-bold m-0 font-usuzi text-uppercase"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "RZOVueJSTheme::SingleUSPs.usp3Head"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("p", { staticClass: "m-0" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "RZOVueJSTheme::SingleUSPs.usp3Text"
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "fs-wishlist mr-3" }, [
                                _vm.isWishListEnabled
                                  ? _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        { staticClass: "col-12" },
                                        [
                                          _c("add-to-wish-list", {
                                            attrs: {
                                              "variation-id":
                                                _vm.currentVariation.variation
                                                  .id
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "fs-rightside d-flex ml-md-3 justify-content-between order-1 order-xl-2 flex-wrap"
                            },
                            [
                              _vm.currentVariation.stock.net <
                                _vm.stockNumber &&
                              _vm.currentVariation.stock.net > 0 &&
                              _vm.showStockWarning == "true"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "fs-shortage d-flex align-self-start"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "alert mb-0 p-2 d-inline-block"
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "font-weight-bold m-0 font-usuzi text-uppercase"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$translate(
                                                    "RZOVueJSTheme::Single.shortageHead"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("p", { staticClass: "m-0" }, [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "RZOVueJSTheme::Single.shortageText"
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "fs-calc d-flex flex-column align-items-end justify-content-end mt-3 mt-md-0"
                                },
                                [
                                  _vm._t("before-price"),
                                  _vm._v(" "),
                                  _vm.currentVariation.filter.isSalable &&
                                  _vm.variationGroupedProperties.length
                                    ? _c("div", [_c("order-property-list")], 1)
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("graduated-prices"),
                                  _vm._v(" "),
                                  _c("item-price", {
                                    attrs: {
                                      "show-cross-price":
                                        _vm.isRecommendedPriceActive
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm._t("after-price"),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "text-right" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "vat small text-muted d-block"
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemFootnote1"
                                                )
                                              ) +
                                              "\n                      "
                                          ),
                                          _vm.showNetPrices
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.singleItemExclVAT"
                                                    )
                                                  )
                                                )
                                              ]
                                            : [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.singleItemInclVAT"
                                                    )
                                                  )
                                                )
                                              ],
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemExclusive"
                                                )
                                              ) +
                                              "\n                      "
                                          ),
                                          _vm.hasShippingCostsCategoryId
                                            ? _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    "data-toggle": "modal",
                                                    href: "#shippingscosts"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "Ceres::Template.singleItemShippingCosts"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            : _c("a", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.singleItemShippingCosts"
                                                    )
                                                  )
                                                )
                                              ])
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c("item-availability")
                                    ],
                                    1
                                  )
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "mb-1 w-100 d-flex button-wrap"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "w-100" },
                                    [_vm._t("before-add-to-basket")],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "w-100 text-right"
                                  }),
                                  _vm._v(" "),
                                  _vm.currentVariation.item.itemType === "set"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "alert alert-info w-100"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemSetInfo"
                                                )
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "col-12 px-0" },
                                        [
                                          _c("add-to-basket", {
                                            attrs: {
                                              "variation-id":
                                                _vm.currentVariation.variation
                                                  .id,
                                              "is-salable":
                                                !!_vm.currentVariation.filter &&
                                                _vm.currentVariation.filter
                                                  .isSalable,
                                              "has-children":
                                                !!_vm.currentVariation.filter &&
                                                _vm.currentVariation.filter
                                                  .hasActiveChildren,
                                              "interval-quantity":
                                                _vm.currentVariation.variation
                                                  .intervalOrderQuantity || 1,
                                              "minimum-quantity":
                                                _vm.currentVariation.variation
                                                  .minimumOrderQuantity,
                                              "maximum-quantity":
                                                !!_vm.currentVariation.variation
                                                  .maximumOrderQuantity &&
                                                _vm.currentVariation.variation
                                                  .maximumOrderQuantity > 0
                                                  ? _vm.currentVariation
                                                      .variation
                                                      .maximumOrderQuantity
                                                  : null,
                                              "order-properties": _vm.currentVariation.properties.filter(
                                                function(prop) {
                                                  return prop.property
                                                    .isOderProperty
                                                }
                                              ),
                                              "has-order-properties":
                                                _vm.currentVariation
                                                  .hasOrderProperties,
                                              "has-required-order-property":
                                                _vm.currentVariation
                                                  .hasRequiredOrderProperty,
                                              "use-large-scale": false,
                                              "show-quantity": true,
                                              "item-url": _vm._f("itemURL")(
                                                _vm.currentVariation
                                              ),
                                              "is-variation-selected":
                                                _vm.isVariationSelected &&
                                                _vm.currentVariation.filter
                                                  .isSalable,
                                              "has-price": _vm._f(
                                                "hasItemDefaultPrice"
                                              )(_vm.currentVariation)
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "w-100" },
                                    [_vm._t("after-add-to-basket")],
                                    2
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm._t("additional-content-after-vat")
                            ],
                            2
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._t("additional-content-after-add-to-basket")
                    ],
                    2
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.currentVariation.texts.shortDescription !== ""
              ? _c("div", { staticClass: "container-fluid fs-seo" }, [
                  _c("div", { staticClass: "container-max mt-4" }, [
                    _c("div", {
                      staticClass: "single-description row",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.currentVariation.texts.shortDescription
                        )
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "container-fluid fs-list-container" }, [
              _c(
                "div",
                { staticClass: "container-max" },
                [_vm._t("item-list-container")],
                2
              )
            ]),
            _vm._v(" "),
            _vm._t("fs-questions"),
            _vm._v(" "),
            _vm._t("feedback-container")
          ]
        },
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }